import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import IconButton from 'material-ui/IconButton'
import AccountCircleIcon from 'material-ui-icons/AccountCircle'
import MUIAvatar from 'material-ui/Avatar'
import {grey} from 'material-ui/colors/index'

const styles = () => ({
  avatar: {
    backgroundColor: grey[400],
  },
  root: {
    width: 36,
    height: 36,
  },
})

const Avatar = ({classes, openMenu, picture}) => (
  <IconButton onClick={openMenu} style={{width: 48}}>
    {picture && picture !== ''
      ? <MUIAvatar className={classes.avatar} classes={{root: classes.root}} src={picture} alt="user"/>
      : <MUIAvatar className={classes.avatar} classes={{root: classes.root}}><AccountCircleIcon/></MUIAvatar>
    }
  </IconButton>
)

Avatar.propTypes = {
  openMenu: PropTypes.func.isRequired,
  picture: PropTypes.string,
}

export default withStyles(styles)(Avatar)



// WEBPACK FOOTER //
// ./src/sections/header/components/avatar.js